module.exports = __webpack_public_path__ + "img/login_banner_1.d20c2833.png";